module.exports = __webpack_public_path__ + "img/tips.a4a6b7e9.webp";